import { FindAndReplace } from '../types';

const getAffectedChartDefinitions = ({
  reportGadgets,
  chartDefinitionIds,
}: {
  reportGadgets: FindAndReplace.PersistedReportGadget[];
  chartDefinitionIds: string[];
}): FindAndReplace.AffectedContentDetails[] =>
  reportGadgets.flatMap(({ chartDef }) =>
    chartDef && chartDefinitionIds.includes(chartDef.id)
      ? [{ id: chartDef.id, name: chartDef.name }]
      : [],
  );

export default getAffectedChartDefinitions;
